import { useSelector } from 'react-redux';
import { createGetExperiment, getIsPdpBoosterExperiment } from 'features/page-model';
import { getIsBoosterAvailable, isCalculatorAvailable } from 'features/product-info';
import { HIDE_CALCULATOR_INTERNAL_ID } from 'common/constants';

export const useBannerMeta = () => {
  const isCalcHidden = useSelector(createGetExperiment(HIDE_CALCULATOR_INTERNAL_ID));
  const isCalcAvailable = (useSelector(isCalculatorAvailable) && !isCalcHidden) ?? false;
  const isShowBooster = useSelector(getIsBoosterAvailable) ?? false;
  const isPdpBoosterExperimentAvailable = useSelector(getIsPdpBoosterExperiment);
  const isBoosterAvailable = isShowBooster && isPdpBoosterExperimentAvailable;
  const isShowBoosterButton = !isCalcAvailable && isBoosterAvailable;

  return { isCalcAvailable, isShowBoosterButton };
};
